import { EmailSuppressionRemoved } from "@signalist/shared-types";

import { api } from "@/redux/api";

import {
	EmailSuppressionPage,
	EmailSuppressionPageParams,
	EmailSuppressionPageSchema,
	EmailSuppressionRemovedSchema,
} from "../../pages/DoNotContact/schema/suppression";

/** The Suppressed tab of Do-not-contact (PREC-4266): the workspace's suppressed addresses. */
export const contactSuppressionApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getEmailSuppressions: builder.query<EmailSuppressionPage, EmailSuppressionPageParams>({
			query: ({ page, limit, searchValue }) => ({
				url: "contact/suppressions",
				params: { page, limit, ...(searchValue && { searchValue }) },
				responseSchema: EmailSuppressionPageSchema,
			}),
			providesTags: ["EmailSuppression"],
		}),
		removeEmailSuppression: builder.mutation<EmailSuppressionRemoved, number>({
			query: (id) => ({
				url: `contact/suppressions/${id}`,
				method: "DELETE",
				responseSchema: EmailSuppressionRemovedSchema,
			}),
			invalidatesTags: ["EmailSuppression"],
		}),
	}),
});

export const { useGetEmailSuppressionsQuery, useRemoveEmailSuppressionMutation } =
	contactSuppressionApi;
